import { createFileRoute } from "@tanstack/react-router";
import { MarketDetailView } from "@/components/markets/MarketDetailView";
import { marketMetaLoader, marketHeadFromLoader } from "@/lib/marketSeo";

// Explore-scoped detail page. Sits under /explore/* (the trailing `_` keeps it
// out of the list's layout) so the Explore nav tab stays active and "Back"
// returns to the filtered list — the selected category survives the round-trip.
export const Route = createFileRoute("/_app/explore_/$id")({
  // Same market, second canonical URL — self-canonicalizes to /explore/:id
  // so a link shared from Explore previews (and indexes) as the page the
  // sharer was actually on. SM-381.
  loader: marketMetaLoader,
  head: marketHeadFromLoader((id) => `/explore/${id}`),
  validateSearch: (
    s: Record<string, unknown>,
  ): { tab?: string; range?: string; cat?: string; q?: string; trade?: string; side?: "buy" | "sell"; pos?: number } => ({
    tab: typeof s.tab === "string" ? s.tab : undefined,
    range: typeof s.range === "string" ? s.range : undefined,
    cat: typeof s.cat === "string" ? s.cat : undefined,
    q: typeof s.q === "string" ? s.q : undefined,
    // Trade intent: the member market + its outcome index (pos). side="buy" (a
    // card Yes/No tap) preselects it; side="sell" (portfolio "Sell") pins SELL.
    trade: typeof s.trade === "string" ? s.trade : undefined,
    side: s.side === "sell" || s.side === "buy" ? s.side : undefined,
    pos: s.pos == null ? undefined : Number.isFinite(Number(s.pos)) ? Number(s.pos) : undefined,
  }),
  component: ExploreMarketDetail,
});

function ExploreMarketDetail() {
  const { id } = Route.useParams();
  const { cat, q, trade, side, pos } = Route.useSearch();
  return (
    <MarketDetailView
      id={id}
      back={{ kind: "explore", cat, q }}
      tradeIntent={trade ? { marketId: trade, pos: pos ?? 0, side: side ?? "buy" } : undefined}
    />
  );
}
